export const environment = {
  production: true,
  appVersion: require('../../package.json').version + '-devessp',
  appName: require('../../package.json').name,
  appPrefix: 'partnernav',

  partnernavBackendUrl: 'https://essp-api-besalesnavigator-dev.acp-gruppe.com',
  portalMetaBackendUrl: 'https://essp-api-beportalmetadata-dev.acp-gruppe.com',
  portalHomeUrl: 'https://essp-dev.acp-gruppe.com',
  stage: 'dev',

  issuer: 'https://ciam-dev.acp-gruppe.com',
  tokenEndpoint: 'https://ciam-dev.acp-gruppe.com/token-srv/token',
  clientId: '43944adf-10e1-4ba2-bd21-f066eff049d4',
  scope: 'openid profile roles groups acpprofile offline_access',
};
